import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { switchMap, tap } from 'rxjs';
import { AnchorModel, DocentiPub, Subtree } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-page-docenti',
  templateUrl: './page-docenti.component.html',
  styleUrls: ['./page-docenti.component.scss']
})
export class PageDocentiComponent implements OnInit {

  @ViewChild('modalDidatticaDettaglio') modalDidatticaDettaglio: any;
  @Input() node: any;
  @Input() anchorItems: AnchorModel[] = [];
  @Input() levelMenu: Subtree[] = [];
  @Input() isSecondLevelUp: boolean = false;
  public idAnchor: string = '';
  public block: any;
  public imgPath = "";
  public isSpinner: boolean = false;
  public domainWebsite = environment.urlApi;
  public titlePage: string = '';
  public ruoloDocente: any[] = [];
  public dipartimentoDocente: any[] = [];
  public corsoLaureaDocente: any[] = [];
  public keywords: any[] = [];
  public truncatedCV: string = '';
  public showMore: boolean = false;
  public dataAvvisi: any;
  public insegnamentiFiltered: any[] = [];
  public formSelectStep2!: FormGroup;
  public partizione: any;
  public dataInsegnamento: any;
  public modalitaApprendimento: string = '';
  public pubblicazioniFirst: DocentiPub[] = [];
  public pubblicazioniOther: DocentiPub[] = [];
  public isOtherPub: boolean = false;
  public cv: any;
  public isCollapseHeader: boolean = false;
  public isShowLocalMenu: any;
  public dataFieldTaxonomies: any[] = [];
  public visibleHeight: number = 300;
  //ANCORE FISSE
  public anchorData: string[] = ['informazioni', 'avvisi', 'didattica', 'ricerca', 'materiali'];
  public anchorLabelTranslate: string[] = ['CONTENT_TYPES.PAGE_DOCENTI.ANCHOR.INFORMATION', 'CONTENT_TYPES.PAGE_DOCENTI.ANCHOR.NOTICES', 'CONTENT_TYPES.PAGE_DOCENTI.ANCHOR.DIDACTICS', 'CONTENT_TYPES.PAGE_DOCENTI.ANCHOR.RESEARCH', 'CONTENT_TYPES.PAGE_DOCENTI.ANCHOR.MATERIALS'];
  public anchorLength: number = 0;
  //MODALE SHARE
  public onHoverShare: boolean = false;
  // public columnFieldTaxonomies: string = '';
  public customOptionsOwl: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    navSpeed: 700,
    autoWidth: true,
    autoHeight: false,
    dots: false,
    nav: true,
    navText: ['<i class="fa-solid fa-chevron-left" aria-hidden="true"></i>', '<i class="fa-solid fa-chevron-right" aria-hidden="true"></i>'],
  };

  constructor(
    private helpersService: HelpersService,
    public nodeService: NodeService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.getDocente();
    this.isSpinner = true;
    this.formDidattica();
    this.helpersService.showLocalMenuBS.subscribe(value => {
      this.isShowLocalMenu = value;
    });    
  }

  @HostListener('document:scroll', ['$event'])
  public onViewportScroll() {
    let boundingCollapse;
    if (this.isSpinner && this.block && this.block.recupera_info_ricerca_scientifica) {
      boundingCollapse = document.querySelector('.container-field-taxonomies')?.getBoundingClientRect();
    } else if (this.isSpinner && this.block && !this.block.recupera_info_ricerca_scientifica) {
      boundingCollapse = document.querySelector('.container-page-general')?.getBoundingClientRect();
    }
    if ((boundingCollapse && boundingCollapse.y < -40 && boundingCollapse.width > 767) || (boundingCollapse && boundingCollapse.y < -200 && boundingCollapse.width <= 767)) {
      this.isCollapseHeader = true;
    } else {
      this.isCollapseHeader = false;
    }
  }

  private getDocente(): void {
    this.nodeService.getRestDocentiCorso(this.node.langcode[0].value, 'docente', this.node.nid[0].value, this.node.preview).pipe(
      tap(docente => {
        this.block = docente;
        //Case CV
        this.checkRicercaScientificaCV(docente);
        let pubblicazioni: DocentiPub[] = docente.id_ricerca_scientifica && docente.recupera_info_ricerca_scientifica ? 
                                          docente.dati_ricerca_scientifica.publications : 
                                          docente.publicazioni && docente.publicazioni.length ? 
                                          docente.publicazioni : [];
        if (pubblicazioni && pubblicazioni.length) {
          pubblicazioni.forEach((pub, idx) => {
            if (idx < 6) {
              this.pubblicazioniFirst.push(pub);
            } else {
              this.pubblicazioniOther.push(pub);
            }
          });
        }

        if (docente.insegnamenti_esse3) {
          const insegnamenti_temp = Object.values(docente.insegnamenti_esse3).sort(function(a: any, b: any) {
            // Ordina per aaOffID dal più grande al più piccolo
            if (a.aaOffID > b.aaOffID) {
              return -1;
            }
            if (a.aaOffID < b.aaOffID) {
              return 1;
            }
            // Se aaOffID è lo stesso, ordina per nome_insegnamento_generale dalla A alla Z
            if (a.cds.cds_nome < b.cds.cds_nome) {
              return -1;
            }
            if (a.cds.cds_nome > b.cds.cds_nome) {
              return 1;
            }
            return 0;
          });
  
          this.block = {
            ...this.block,
            insegnamenti_esse3: insegnamenti_temp
          }

        }
        
        this.imgPath = this.domainWebsite + this.block.foto;
        // this.setColumnFieldTaxonomies(this.block);
        this.setCarouselItems(this.block.ricerche_pubblicazioni.length);

        if(this.block.dettaglio_ruoli_docente){
          this.ruoloDocente = [{value: this.block.dettaglio_ruoli_docente}];
        } else if (this.block.tassonomia_ruolo_docente) {
          this.ruoloDocente = this.getTassonomiaBlock(this.block.tassonomia_ruolo_docente);
        }
        
        if (this.block.tassonomia_dipartimento) {
          this.dipartimentoDocente = this.getTassonomiaBlock(this.block.tassonomia_dipartimento);
        }
        if (this.block.tassonomia_corsi_di_laurea) {
          this.corsoLaureaDocente = this.getTassonomiaBlock(this.block.tassonomia_corsi_di_laurea);
        }
        if (this.block.tassonomia_keyword_tematiche) {
          this.keywords = this.getTassonomiaBlock(this.block.tassonomia_keyword_tematiche);
        }
        this.setDataFields(this.ruoloDocente, this.dipartimentoDocente, this.corsoLaureaDocente);
      }),
      switchMap((docente) => this.nodeService.getRelatedViewAvvisiAutore(this.node.langcode[0].value, 'avvisi', docente.author, this.node.preview))
    ).subscribe(dataAvvisiAuthor => {
      this.dataAvvisi = dataAvvisiAuthor;
      this.anchorItems = [
        ...this.anchorItems,
        ...this.setAnchorWithIds(this.anchorData)
      ];
      this.anchorLength = this.anchorItems.length;
    });
  }

  private checkRicercaScientificaCV(docente: any): void {
    if (docente.recupera_info_ricerca_scientifica) {
      const docenteCvRicerca = docente.dati_ricerca_scientifica.cv;
      if (docenteCvRicerca && docenteCvRicerca.description) {
        this.cv = docenteCvRicerca.description;
        // this.truncatedCV = this.setTruncatedText(this.cv);
      } else {
        if (docente.curriculum.length) {
          this.cv = docente.curriculum[0].value;
          // this.truncatedCV = this.setTruncatedText(this.cv);
        } else {
          this.cv = null;
        }
      }
    } else {
      if (docente.curriculum.length) {
        this.cv = docente.curriculum[0].value;
        // this.truncatedCV = this.setTruncatedText(this.cv);
      } else {
        this.cv = null;
      }
    }
    
  }

  // private setTruncatedText(data: string): string {
  //   if (data.length > 990) {
  //     return data.substring(0, 990) + '...';
  //   } else {
  //     return data;
  //   }
  // }

  private getTassonomiaBlock(tassonomia: any[]): any {
    let data: any[] = [];
    if (this.nodeService.taxonomies) {
      tassonomia.map((tassonomia: any) => {
        const dataTEmp = this.nodeService.taxonomies.find((el: any) => el.term_id === tassonomia.target_id.toString());
        if (dataTEmp) {
          data.push(dataTEmp);
        }
      });
    }
    return data;
  }

  public addNewAnchorItem(value: AnchorModel): void {
    setTimeout(() => {
      if (value.labelRow !== '') {
        this.anchorItems.push(value);
      }
    }, 50);
    // this.idAnchor = this.anchorItems[0].idRow;
  }

  public modaleDidatticaDettaglio(data: any): void {
    this.modalService.open(this.modalDidatticaDettaglio, {
      scrollable: false,
      centered: true,
      size: 'xl'
    });
    this.dataInsegnamento = data;
    this.modalitaApprendimento = data.modalità_verifica_apprendimento;
  }

  private formDidattica(): void {
    this.formSelectStep2 = this.formBuilder.group({
      partizione_selezionata: new FormControl(this.partizione),
    });
    this.formSelectStep2.valueChanges.subscribe(res => {
      this.partizione = this.dataInsegnamento.partizioni.find((el: any) => el.nome_partizione === res.nome_partizione);
    });
  }

  public isExternalLink(link: string): boolean {
    return link ? this.nodeService.verifyLinkExternal(link) : false;
  }

  private setCarouselItems(items: number): void {
    this.customOptionsOwl = {
      ...this.customOptionsOwl,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 2
        },
        900: {
          items: 4
        }
      }
    }
  }

  public openMenu(): void {
    this.helpersService.openLocalMenuBS.next(true);
  }

  private setDataFields(ruoloDocente: any, dipartimentoDocente: any, corsoLaureaDocente: any): void {
    if (ruoloDocente.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_DOCENTI.ROLE',
          value: ruoloDocente,
          isArray: true
        }
      ]
    }
    if (this.node.field_citta && this.node.field_citta.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_ALLOGGIO.CITY',
          value: this.node.field_citta,
          isArray: true
        }
      ]
    }
    if (dipartimentoDocente.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_DOCENTI.DEPARTMENT',
          value: dipartimentoDocente,
          isArray: true
        }
      ]
    }
    if (corsoLaureaDocente.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_DOCENTI.DEGREE_COURSE',
          value: corsoLaureaDocente,
          isArray: true
        }
      ]
    }
  }

  private setAnchorWithIds(ids: string[]): AnchorModel[] {
    const result = [];
    if(this.helpersService.isBrowser) {
      for (let i = 0; i < ids.length; i++) {
        const element = document.getElementById(ids[i]);
        if (element) {
          result.push({
            idRow: ids[i],
            labelRow: this.anchorLabelTranslate[i],
            position: result.length
          })
        }
      }
    }
    return result;
  }

  public formatHtml(htmlString: string) {
    return htmlString.replaceAll('\n','<br>');
  }

}
